import React, { useState, useEffect } from "react";
import "../Assests/Scss/Assessment.scss";
import { useNavigate } from "react-router-dom";
import axios from "axios";
// Below import is for date formats
import { format } from "date-fns";
// below imports is for images
import Welcome1 from "../Assests/Images/Cimages/Welcome1.webp";
import Welcome2 from "../Assests/Images/Cimages/Welcome2.webp";
// Below import is for icons
import { IoIosTimer } from "react-icons/io";
// Below import is for components
import CopyRight from "../Reusablecomponents/Copyright";
import InternetChecking from "../Reusablecomponents/Network";
import { AssessmentName } from "../Reusablecomponents/RegularFunctions";
import { useSelector } from "react-redux";
import WithTranslate from "../../ReusableComponents/StaticTranslater/Translater";

const Teststaus = () => {
  const navigate = useNavigate();
  // Below is for getting the user details
  const items = useSelector((state) => state.userDetailsData.LoginDetails);
  const AssessmentData = JSON.parse(localStorage.getItem("AssessmentData"));

  // Below is for variables / useState
  const [ExamTimeings, SetExamTimeings] = useState();
  // Below is for Api's
  const APIURL = process.env.REACT_APP_API_BASE_URL;
  const APIKEY = process.env.REACT_APP_XApiKey;
  const StudentAttendance = APIURL + "/Assessment/GetStudentAttendance?";
  const GetExamTimeings = async () => {
    await axios
      .get(
        StudentAttendance +
          `ContestCreationId=${AssessmentData?.contestCreationID}&UserId=${items.userId}&AssessmentType=${AssessmentData.assessmentType}`,
        { headers: { XApiKey: APIKEY } }
      )
      .then((res) => {
        SetExamTimeings(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    GetExamTimeings();
  }, []);

  const StarTest = () => {
    if (
      navigator.onLine &&
      new Date(AssessmentData?.examStartDateTime) <= new Date()
    ) {
      localStorage.removeItem("timeupAlertShown");
      if (
        AssessmentStatus() &&
        (AssessmentData?.testType === "single"
          ? ExamTimeings?.[`sub${AssessmentData?.subjectNo}Attended`] !== 1
          : ExamTimeings?.isAttended !== 1)
      ) {
        // if (ExamTimeings.isSubmitted !== 1 && ExamTimeings.isAttended !== 1) {
        navigate("/Student/Instructions", { replace: true });
        localStorage.removeItem("ResumeId");
      } else if (
        (AssessmentData?.testType === "single"
          ? ExamTimeings?.[`sub${AssessmentData?.subjectNo}Attended`] === 1
          : ExamTimeings?.isAttended === 1) &&
        ExamTimeings.isSubmitted !== 1
      ) {
        // } else if (
        //   new Date(ExamTimeings.testEndDateTime) > new Date() &&
        //   ExamTimeings.isAttended === 1 &&
        //   ExamTimeings.isSubmitted !== 1
        // ) {
        localStorage.setItem("ResumeId", "Resume");
        navigate("/Student/Answersheet", { replace: true });
      }
    }
  };

  const GetExamStatus = (AssessmentData, ExamTimeings) => {
    switch (true) {
      // case new Date(AssessmentData?.examStartDateTime) > new Date():
      //   return "Wait for Assessment";
      // case new Date(ExamTimeings?.testEndDateTime) < new Date():
      //   return "Assessment already taken";
      case AssessmentData?.testType === "single"
        ? ExamTimeings?.[`sub${AssessmentData?.subjectNo}Attended`] === 0
        : ExamTimeings?.isAttended === 0:
        // case ExamTimeings?.isAttended === 0:
        return "Begin Assessment";
      case ExamTimeings?.isSubmitted === 1:
        return "Assessment already taken";
      case AssessmentData?.testType === "single"
        ? ExamTimeings?.[`sub${AssessmentData?.subjectNo}Attended`] === 1
        : ExamTimeings?.isAttended === 1:
        // case ExamTimeings?.isAttended === 1:
        return "Resume Assessment";
      default:
        return "";
    }
  };

  const AssessmentStatus = () => {
    if (AssessmentData?.testType !== "single") {
      if (ExamTimeings?.isSubmitted !== 1) {
        return true;
      }
    } else if (ExamTimeings[`Sub${AssessmentData?.subjectNo}Submitted`] !== 1) {
      return true;
    }
  };
  return (
    <>
      <div className="Teststatus-Maindiv flexd-column">
        <InternetChecking />
        <div className="Welcome-User dflex">
          <img src={Welcome2} alt="Welcome2" />
          <div className="Exam-Details">
            <span>{AssessmentName(AssessmentData?.assessmentType)}</span>
            {AssessmentData ? (
              <>
                <div>
                  {" "}
                  {format(
                    new Date(AssessmentData?.examStartDateTime),
                    "do MMMM yyyy hh:mm a"
                  )}{" "}
                  to{" "}
                  {format(
                    new Date(AssessmentData?.examEndDateTime),
                    "do MMMM yyyy hh:mm a"
                  )}
                </div>
                <div>
                  <span>
                    {/* {AssessmentData?.assessmentType === 3 &&
                    items?.grade <= 10 ? ( */}
                     { AssessmentData?.allSubjectNames.replace(/,/g, " | ")}
                    {/* // ) : (
                    //   <>
                    //     {AssessmentData?.subject1Name}{" "}
                    //     {AssessmentData?.testType !== "single" &&
                    //       `| ${AssessmentData?.subject2Name} | ${AssessmentData?.subject3Name}`}
                    //   </>
                    // )} */}
                  </span>
                  <span>
                    <IoIosTimer fontSize={30} /> {AssessmentData?.duration} min
                  </span>
                </div>
              </>
            ) : (
              <div>No records found</div>
            )}

            {AssessmentData && (
              <button
                className={
                  GetExamStatus(AssessmentData, ExamTimeings) ===
                    "Assessment already taken" ||
                  GetExamStatus(AssessmentData, ExamTimeings) ===
                    "Wait for Assessment"
                    ? "Buttons cNodrop"
                    : "Buttons"
                }
                onClick={StarTest}
              >
                {GetExamStatus(AssessmentData, ExamTimeings)}
              </button>
            )}
          </div>
          <img src={Welcome1} alt="Welcome1" className="Students" />
        </div>

        {/* Below is for guide lines */}
        <div className="GuideLines">
          <h5>
            <WithTranslate name="Guidelines.Guidelines" />
          </h5>
          <ol className="GuideLines-List">
            <li>
              <b>
                {" "}
                <WithTranslate name="Guidelines.Invigilator" />
              </b>
            </li>
            <li>
              <b>
                {" "}
                <WithTranslate name="Guidelines.TestWindow" />
              </b>
            </li>
            <li>
              {" "}
              <WithTranslate name="Guidelines.Processed" />
            </li>
            <li>
              {" "}
              <WithTranslate name="Guidelines.TimerBold" />
            </li>
            {/* <li>
              {" "}
              <WithTranslate name="Guidelines.Timer" />
            </li> */}
            <li>
              {" "}
              <WithTranslate name="Guidelines.QuestionPalette" />
            </li>

            <ul
              className="QDetails"
              style={{ listStyleType: "none", padding: "0px" }}
            >
              <li>
                <b>
                  <WithTranslate name="Guidelines.AnsweredTextHeading" />
                </b>{" "}
                <WithTranslate name="Guidelines.AnsweredText" />
              </li>
              <li>
                <b>
                  <WithTranslate name="Guidelines.MarkedforReviewHeading" />
                </b>{" "}
                <WithTranslate name="Guidelines.MarkedforReview" />
              </li>
              <li>
                <b>
                  <WithTranslate name="Guidelines.NotVisitedTextHeading" />
                </b>{" "}
                <WithTranslate name="Guidelines.NotVisitedText" />
              </li>
            </ul>
          </ol>
          <CopyRight />
        </div>
      </div>
    </>
  );
};
export default Teststaus;
